/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useState } from 'react';
import { useSelector } from 'react-redux';

import { useBroadcastForm } from '../useBroadcastForm';
import { useFetchBroadcastRecipients } from '../hooks/useFetchBroadcastRecipients';
import { useFetchRecipientRows } from '../hooks/useFetchRecipientRows';
import { useFetchBoardTier } from '../hooks/useFetchBoardTier';
import { ME, resolvePreviewPerson } from '../utils/recipientPreview';

import { PAID } from '../utils/constants';

const BroadcastContext = createContext();

export const BroadcastContextProvider = props => {
  const {
    canSendBroadcast,
    tier,
    nextFreeBroadcastDate,
    linkTrackingDisabled,
  } = useFetchBoardTier();
  const broadcastForm = useBroadcastForm({
    currentStep: props.currentStep,
  });
  const isLimitReached = !canSendBroadcast && tier && tier !== PAID;
  const { broadcastRecipients } = useFetchBroadcastRecipients({
    id: broadcastForm.values.uuid,
  });
  const hasAudiences = (broadcastForm.values.audiences || []).length > 0;
  const { recipientRows, recipientRowsTotal } = useFetchRecipientRows({
    id: broadcastForm.values.uuid,
    enabled: hasAudiences,
  });
  const currentUser = useSelector(state => state.currentUser);

  // Shared by Review.jsx (the select + send-test button) and Sms.jsx (the
  // phone preview), so picking a person in one place drives both.
  const [previewAsUuid, setPreviewAsUuid] = useState(ME);
  const previewPerson = resolvePreviewPerson({
    selectedUuid: previewAsUuid,
    currentUser,
    recipientRows,
  });

  return (
    <BroadcastContext.Provider
      value={{
        ...broadcastForm,
        ...broadcastRecipients,
        recipientRows,
        recipientRowsTotal,
        currentUser,
        previewAsUuid,
        setPreviewAsUuid,
        previewPerson,
        canSendBroadcast,
        isLimitReached,
        tier,
        nextFreeBroadcastDate,
        linkTrackingDisabled,
      }}
    >
      {props.children}
    </BroadcastContext.Provider>
  );
};

export const useBroadcastContext = () => useContext(BroadcastContext);
